import { render, staticRenderFns } from "./SuccessLogin.vue?vue&type=template&id=72d903ef&scoped=true"
import script from "./SuccessLogin.vue?vue&type=script&lang=js"
export * from "./SuccessLogin.vue?vue&type=script&lang=js"
import style0 from "./SuccessLogin.vue?vue&type=style&index=0&id=72d903ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d903ef",
  null
  
)

export default component.exports